module.exports = __webpack_public_path__ + "static/media/MyriadPro-BoldCond-01.f0b9d480.svg";